import { TypeCoord } from './TypeCoord';
import { TypePers } from './TypePers';
import { TypeAdresse } from './TypeAdresse';
export class TypeAdresseCompleteObligatoire {

	public correspondantPRM: TypePers;

	public coord: TypeCoord;

	public acheteurPublic: string;

	public classificationOrganisme: string;

	public adr: TypeAdresse;

	public urlProfilAcheteur: string;

	constructor() {
		this.correspondantPRM = new TypePers();
		this.coord = new TypeCoord();
		this.acheteurPublic = '';
		this.classificationOrganisme = '';
		this.adr = new TypeAdresse();
		this.urlProfilAcheteur = '';

	}
}
